export enum CoreInjectorTokensV2 {
    Environment = "environment",
    LoginUrl = "login-url",
}
